export default __webpack_public_path__ + "static/media/DryerPaymentLogo.5e3895f5.png";